import axios, { AxiosRequestConfig } from 'axios';
import { TGetAllRequestsResponse, TGetAllRequestsProps } from './types';

export const getAllRequests = async ({
  companyName = '',
  locationName = '',
  userAccessToken,
  page = 0,
  pageSize = 10,
  query = '',
  status = '',
  ofPeriod = '',
  toPeriod = '',
  isFetching,
}: TGetAllRequestsProps): Promise<TGetAllRequestsResponse> => {
  try {
    if (isFetching) isFetching(true);
    const apiPath = `${process.env.REACT_APP_SYNC_PLATFORM_REQUESTS}`;

    const requestOptions: AxiosRequestConfig = {
      headers: {
        Authorization: `Bearer ${userAccessToken}`,
      },
      params: {
        page,
        pageSize,
        query,
        status,
        ofPeriod,
        toPeriod,
        locationName,
        companyName,
      },
    };

    const { data } = await axios.get(apiPath, requestOptions);

    return data;
  } catch (err) {
    return null;
  } finally {
    if (isFetching) isFetching(false);
  }
};
